import { render, staticRenderFns } from "./AccountModal.vue?vue&type=template&id=61b65600&scoped=true&"
import script from "./AccountModal.vue?vue&type=script&lang=js&"
export * from "./AccountModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b65600",
  null
  
)

export default component.exports